























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  private timeoutId: number = -1;
  private isTimeout: boolean = false;

  @Prop({ type: Boolean, default: true })
  public isShow!: boolean;

  @Prop({ type: String, required: false })
  public cautionHtml!: string;

  // 手動撮影で撮影済みの状態 手動撮影ではtriggerShootがtrueになったらあとはページ遷移をするので、撮影済みと同義である
  private get isManualTriggered(): boolean {
    return !this.$store.state.camera.isDetectStart && this.$store.state.camera.triggerShoot;
  }

  private get top(): number {
    return this.$store.state.camera.displayIdDocCenter;
  }

  mounted(): void {
    this.timeoutId = window.setTimeout((): void => {
      this.isTimeout = true;
    }, 3000);
  }

  beforeDestroy(): void {
    window.clearTimeout(this.timeoutId);
  }
}
